import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
export function TestimonialsExtended() {
  const testimonials = [{
    initials: 'CR',
    name: 'Claudia R.',
    location: 'Mendoza',
    rubro: 'Tienda de ropa',
    text: "Los prompts del Tomo 2 me cambiaron la vida. Ahora respondo 'está caro' sin perder la venta. Este mes vendí 35% más que el mes anterior."
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    rubro: 'Electricista independiente',
    text: 'Armé el sistema de turnos automáticos en una tarde. Mis clientes ahora sacan turno solos y reciben recordatorio solo. Me libera 2 horas por semana mínimo.'
  }, {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    rubro: 'Pastelería artesanal',
    text: 'El calendario de contenido del Tomo 3 me salvó. Antes tardaba 3 horas en planificar la semana. Ahora 20 minutos y queda mejor que antes.'
  }, {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    rubro: 'Consultor de RRHH',
    text: 'Los prompts de finanzas del Tomo 5 me ayudaron a descubrir que uno de mis servicios me generaba pérdida. Lo corregí y recuperé $40.000 pesos por mes de margen.'
  }, {
    initials: 'VL',
    name: 'Valeria L.',
    location: 'Córdoba',
    rubro: 'Centro de estética',
    text: 'Configuré Make con WhatsApp Business siguiendo el Tomo 4. Ahora los turnos se confirman solos y los recordatorios se mandan solos. No perdí un turno más por olvido del cliente.'
  }, {
    initials: 'JM',
    name: 'Jorge M.',
    location: 'Rosario',
    rubro: 'Delivery de comida casera',
    text: 'El sistema de pedidos automáticos del Tomo 4 me salvó los fines de semana. Antes era un caos. Ahora los pedidos entran, se confirman y se registran solos.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-269">
      <div className="text-center mb-12" data-id="element-270">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-271">
          ❤️ Más emprendedores que ya lo tienen
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-272">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-dark border border-brand-violet/30 rounded-2xl p-6 relative overflow-hidden group hover:border-brand-violet transition-colors" data-id="element-273">
            <div className="flex items-center gap-4 mb-4" data-id="element-274">
              <div className="w-12 h-12 rounded-full bg-brand-violet/20 flex items-center justify-center text-brand-violet font-bold text-lg border border-brand-violet/30" data-id="element-275">
                {t.initials}
              </div>
              <div data-id="element-276">
                <p className="text-white font-bold" data-id="element-277">{t.name}</p>
                <div className="flex gap-1 mb-1" data-id="element-278">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 fill-brand-gold text-brand-gold" data-id="element-279" />)}
                </div>
              </div>
            </div>

            <p className="text-gray-300 mb-6 italic text-sm" data-id="element-280">"{t.text}"</p>

            <div className="flex items-center gap-2 text-xs text-gray-400 mt-auto pt-4 border-t border-white/10" data-id="element-281">
              <MapPin className="w-3 h-3" data-id="element-282" />
              <span data-id="element-283">{t.location}</span>
              <span className="mx-1" data-id="element-284">•</span>
              <span data-id="element-285">{t.rubro}</span>
            </div>
          </motion.div>)}
      </div>
    </section>;
}